module.exports = "/images/model_abd321.png";